import { Injectable } from '@angular/core';

@Injectable()
export class InactivityCountdownHttpHandlerService {
    Reset = () => {};
}
